import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./index.css";
import i18n from "./i18n";
import "./debug-env";
import { logEnvironmentVariables } from "./utils/env-debug";

// Run environment debugging
logEnvironmentVariables();
// testApiUrls();

// const testApiUrls = ['/api/users', '/api/roles'];

// Log API URL for debugging
console.log("API URL:", import.meta.env.VITE_API_URL);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </StrictMode>,
);
